import React, { useEffect, useRef, useState } from 'react';
import { Col, FormGroup, Label } from 'reactstrap';
import { getInputStatus } from '../../../services/commonServices';
import PrintInputError from '../../InputUtils/PrintInputError';

import { Types } from '../../../utils/DynamicForm.config';
import InputDescription from '../../InputUtils/InputDescription';
import useStaticFormListener from '../../../hooks/useStaticFormListener';
import authenticatedFetcher from '../../../services/fetcher';

const TypeFormInputNumeric = ({
	label,
	name,
	value,
	editable,
	onChange,
	isEditing = true,
	required,
	errors,
	isOperations,
	labelColumn = {
		xs: 6,
		md: 2
	},
	inputColumn = {
		xs: 6,
		md: 10
	},
	alwaysEditableFields,
	relatedData,
	options = {},
	formData,
	globalParams = {}
}) => {
	const inputConfig = options;
	const [customParams] = useStaticFormListener({ options, formData });
	const isInitialReload = useRef(true);

	const [localValue, setLocalValue] = useState(value);

	// Reload: cuando customParams cambia (otro campo del formulario fue modificado), hacer fetch y actualizar valor
	useEffect(() => {
		if (Object.values(customParams).length && inputConfig.endpoint) {
			handleReload();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [customParams]);

	const handleReload = async () => {
		const params = inputConfig.params ? inputConfig.params : {};
		const paramsFixed = inputConfig['params-fixed'] ? inputConfig['params-fixed'] : {};
		const data = await authenticatedFetcher({
			path: `${inputConfig.endpoint}`,
			urlParams: {
				...globalParams,
				...params,
				...paramsFixed,
				...customParams,
				from_select: 1,
			},
		});
		const newValue = data[inputConfig.key];
		if (newValue !== undefined) {
			// En la carga inicial, si ya hay un valor guardado (de BD), no machacarlo
			if (isInitialReload.current) {
				isInitialReload.current = false;
				if (value !== undefined && value !== null && value !== '') {
					return;
				}
			}
			setLocalValue(newValue);
			onChange({
				target: {
					name,
					value: newValue,
				},
			});
		}
	};

	useEffect(() => {
		onChange({ target: { value, name } });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		onChange({ target: { value: localValue, name } });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [localValue]);
	useEffect(() => {
		setLocalValue((prev) => (prev === value ? prev : value));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value]);

	const handleChange = (event) => {
		const {
			target: { value }
		} = event;
		setLocalValue(value);
	};

	const isEditable = Array.isArray(alwaysEditableFields)
		? alwaysEditableFields.some((item) => item === name) || editable
		: editable;

	return (
		<FormGroup tag="fieldset" row>
			<Col {...labelColumn}>
				<Label className="form-2-last-name">
					{required ? '*' : ''} {label}
				</Label>
			</Col>
			<Col {...inputColumn}>
				{isEditable && isEditing ? (
					<input
						name={name}
						value={localValue || ""}
						type="number"
						step="any"
						onChange={handleChange}
						autoComplete="off"
						className={`form-control input-text-wrapper validation ${getInputStatus(
							required,
							localValue,
							errors
						)}`}
					/>
				) : (
					<span>{localValue}</span>
				)}
				<PrintInputError errors={errors} />
				<InputDescription description={relatedData ? relatedData.description : ''} />
			</Col>
		</FormGroup>
	);
};

TypeFormInputNumeric.propTypes = Types.inputType;

export default TypeFormInputNumeric;
